import React from 'react';
import { FaCode, FaMobileAlt, FaBolt, FaBalanceScale } from 'react-icons/fa';
import Header from './header';
const features = [
  {
    name: 'Code Editor for HTML, CSS, and JS',
    description: 'Edit text according to your code. Supports HTML, CSS, and JS.',
    icon: FaCode,
  },
  {
    name: 'Live Preview',
    description: 'See live output of your code as you type. Instantly visualize changes.',
    icon: FaMobileAlt,
  },
  {
    name: 'Syntax Highlighting',
    description: 'Code highlighting for improved readability and easier debugging.',
    icon: FaBolt,
  },
  {
    name: 'User-Friendly Interface',
    description: 'Intuitive design with user convenience in mind. Easy to navigate and use.',
    icon: FaBalanceScale,
  },
];


const CodeEditorFeatures = () => {

  return (
    <>
      <Header />
      <div className="bg-white py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:text-center">
            <h2 className="text-base font-semibold leading-7 text-indigo-600">Code Editor Features</h2>
            <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
              Everything You Need for Web Development
            </p>
          </div>
          <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl">
            <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
              {features.map((feature) => (
                <div key={feature.name} className="relative pl-16">
                  <dt className="text-base font-semibold leading-7 text-gray-900">
                    <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-indigo-600">
                      {feature.icon({ className: "h-6 w-6 text-white", "aria-hidden": true })}
                    </div>

                    {feature.name}
                  </dt>
                  <dd className="mt-2 text-base leading-7 text-gray-600">{feature.description}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </>
  );
};

export default CodeEditorFeatures;
